export function formatDateInput(value) {
  if (!value) return "";

  if (typeof value === "string") {
    return value.slice(0, 10);
  }

  return "";
}

export function formatTimeInput(value) {
  if (!value) return "";
  return String(value).slice(0, 8);
}

export function toSeconds(time) {
  if (!time) return 0;

  const [hours, minutes, seconds] = String(time)
    .split(":")
    .map((item) => Number(item || 0));

  return hours * 3600 + minutes * 60 + seconds;
}

export function normalizeTimeValue(value) {
  if (!value) return "";

  const parts = String(value).split(":");
  const hours = String(parts[0] || "00").padStart(2, "0");
  const minutes = String(parts[1] || "00").padStart(2, "0");
  const seconds = String(parts[2] || "00").padStart(2, "0");

  return `${hours}:${minutes}:${seconds}`;
}

export function formatDurationFromSeconds(totalSeconds) {
  const safeSeconds = Math.max(0, totalSeconds || 0);

  const hours = Math.floor(safeSeconds / 3600);
  const minutes = Math.floor((safeSeconds % 3600) / 60);
  const seconds = safeSeconds % 60;

  return [
    String(hours).padStart(2, "0"),
    String(minutes).padStart(2, "0"),
    String(seconds).padStart(2, "0"),
  ].join(":");
}

export function formatSignedDurationFromSeconds(totalSeconds) {
  const sign = totalSeconds < 0 ? "-" : "";
  return sign + formatDurationFromSeconds(Math.abs(totalSeconds || 0));
}

export function getDurationSeconds(startTime, endTime) {
  if (!startTime || !endTime) return 0;

  const diff = toSeconds(endTime) - toSeconds(startTime);
  return diff > 0 ? diff : 0;
}

export function groupRowsByUser(rows) {
  const map = new Map();

  rows.forEach((row) => {
    const key = row.user_id;

    if (!map.has(key)) {
      map.set(key, {
        userId: row.user_id,
        userName: row.user_name || row.user_login || row.user_id,
        userLogin: row.user_login || "",
        rows: [],
      });
    }

    map.get(key).rows.push(row);
  });

  return Array.from(map.values());
}